import React from "react";
import moment from "moment";
function DatePosted({ date, daysOnly = false, format="MMMM Do YYYY, h:mma" }) {
  return moment(date).diff(moment(), "days", false) < -5 && !daysOnly
    ? moment(date).format(format)
    : moment(date).fromNow();
}

export default DatePosted;
